var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"desc-item"},[_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"order"},[_vm._v(_vm._s(_vm.index))]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.item.title))])]),_vm._v(" "),_c('div',{staticClass:"content font-14"},[_vm._v(_vm._s(_vm.item.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/tariff/bottom-desc/desc-item.vue?vue&type=template&id=0bcc8eb8&scoped=true
// module id = null
// module chunks = 